import { useMutation, useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import type { UpdateCoursesDirectoryPayload } from "@/react/api/coursesDirectoryApi";
import { coursesDirectoryApi } from "@/react/api/coursesDirectoryApi";
import { useInvalidateCoursesInfiniteQuery } from "@/react/components/Courses/Directory/useCoursesInfiniteQuery";
import { COURSE_TOPICS_QUERY_KEY } from "@/react/components/Spaces/TopicFilters/hooks/useTopics";
import type { ApiError } from "@/react/config/CustomErrors";
import type { CoursesDirectory } from "@/react/types/CoursesDirectory";
import { useToast } from "@circle-react-uikit/ToastV2";

export const useUpdateCoursesDirectory = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { invalidateCourseQueries } = useInvalidateCoursesInfiniteQuery();

  const { mutate, isLoading: isUpdating } = useMutation<
    CoursesDirectory,
    ApiError,
    UpdateCoursesDirectoryPayload
  >({
    mutationFn: coursesDirectoryApi.update,
    onSuccess: () => {
      toast.success(t("courses.directory.options_modal.saved_successfully"));
      void queryClient.invalidateQueries(COURSE_TOPICS_QUERY_KEY); // invalidate topic filters query
      void queryClient.invalidateQueries(["courses/directory", "show"]); // this is the query key used in the modal
      void invalidateCourseQueries(); // this is the query used in the course directory page
    },
    onError: (error: ApiError) => {
      toast.error(error.message);
    },
  });

  return { mutate, isUpdating };
};
